module.exports = __webpack_public_path__ + "static/media/Background_3.853cb554.svg";